// extracted by mini-css-extract-plugin
export var alertIcon = "_tz-0";